/**
   * Final Shopocado Fix
   * Ignores Digitizing Fee Limiter and only triggers once per product addition
   */

  (function() {
    'use strict';

    let refreshTriggered = false; // Prevent multiple triggers
    let refreshTimeout = null;

    function log(message) {
      console.log('[Final Shopocado]', message);
    }

    // Simple, effective Shopocado refresh
    async function doShopocadoRefresh() {
      log('🔄 Triggering Shopocado refresh...');

      try {
        // Multiple gentle methods to wake up Shopocado

        // 1. Cart attribute update
        await fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            attributes: { '_shopocado_wake': Date.now().toString() }
          })
        });

        // 2. Try calling Shopocado functions directly
        if (window.Shopocado) {
          try {
            if (typeof window.Shopocado.refresh === 'function') {
              window.Shopocado.refresh();
              log('✅ Called Shopocado.refresh()');
            } else if (typeof window.Shopocado === 'function') {
              window.Shopocado();
              log('✅ Called Shopocado()');
            }
          } catch (e) {
            log('⚠️ Shopocado direct call failed:', e);
          }
        }

        // 3. Trigger events
        document.dispatchEvent(new Event('DOMContentLoaded'));
        document.dispatchEvent(new CustomEvent('cart:updated'));

        log('✅ Shopocado refresh completed');

        // Reset flag after a delay
        setTimeout(() => {
          refreshTriggered = false;
          log('🔄 Ready for next product addition');
        }, 5000);

      } catch (error) {
        log('❌ Refresh failed:', error);
        refreshTriggered = false;
      }
    }

    // Monitor for product additions only
    function init() {
      if (typeof PUB_SUB_EVENTS === 'undefined' || typeof subscribe === 'undefined') {
        setTimeout(init, 100);
        return;
      }

      log('✅ Monitoring for product additions');

      subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
        log('📦 Cart event:', {
          source: event.source,
          refreshTriggered: refreshTriggered
        });

        // ONLY trigger for product-form AND if we haven't already triggered
        if (event.source === 'product-form' &&
            event.cartData &&
            !event.cartData.errors &&
            !refreshTriggered) {

          log('⏰ NEW PRODUCT ADDED - will refresh in 2 seconds');
          refreshTriggered = true;

          // Clear any existing timeout
          if (refreshTimeout) {
            clearTimeout(refreshTimeout);
          }

          // Wait longer to let digitizing fee limiter finish
          refreshTimeout = setTimeout(() => {
            doShopocadoRefresh();
          }, 2000); // 2 seconds to let everything settle

        } else if (event.source === 'digitizing-fee-limiter-v4') {
          log('🚫 Ignoring digitizing fee limiter event');
        } else if (refreshTriggered) {
          log('🚫 Refresh already triggered for this addition');
        } else {
          log('🚫 Ignoring cart update - not a product addition');
        }
      });

      log('🎯 Final Shopocado fix active');
    }

    log('🚀 Final Shopocado Fix loading...');
    init();

    // Manual test
    window.testShopocadoRefresh = doShopocadoRefresh;

  })();